import { string, object, boolean } from 'yup';
import { PACKAGE_TYPE, PURCHASE_ORDER_NUMBER, RECEIVING_CENTER } from '../constants';
import { messages } from './messages';

const NO_SPACES = /^\S*$/;

export const SetupConfigurationsSchema = object({
  [RECEIVING_CENTER]: string().required(messages.required),
  [PURCHASE_ORDER_NUMBER]: string()
    .required(messages.required)
    .matches(NO_SPACES, () => messages.purchaseOrderNoSpaces),
  [PACKAGE_TYPE]: string().required(messages.required),
  isComplete: boolean(),
});
